<div class="principal--desktop">
  <app-header></app-header>

  <div class="conteudo">
    <router-outlet></router-outlet>
  </div>
</div>
<p class="version">v 1.1.7</p>